import {l} from "types/typescriptdefinisjoner_lederplan";
import {BasisRessurs} from "felles/infrastruktur/BasisRessurs";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Kontekst} from "../Kontekst";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {IQService} from "angular";

export class MalmøteRessurs extends BasisRessurs<l.MalmøteModell> {

    static regNavn = "malmøteRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            regNavn.ng.$q,
            Kontekst.regNavn,
            Konfigurasjon.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            MalmøteRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                private $q: IQService,
                private kontekst: Kontekst,
                private konfigurasjon: Konfigurasjon,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog) {
        super("malmoete",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {}
        );
    }

    //offentlige metoder

}

